import resolveBehaviour from '../utils/resolve-behaviour';
import subscribe from './subscribe';
import customRace from '../utils/custom-race';
//import dismissed from '../utils/dismissed';

var subscribeByOptions = function(oneSignal, options){
    var behaviourStrategy;
    var args = [oneSignal];
    
    options = options || {};
    
    var behaviours = [];
    
    if (options.strategies && Array.isArray(options.strategies)) {
        options.strategies.forEach(function(strategy) {
            behaviours.push(resolveBehaviour(strategy));
        })
    } else {
        behaviours.push(resolveBehaviour(options));
    }
    behaviourStrategy = customRace(behaviours);
    args.push(behaviourStrategy);
//    if (dismissed((options || {}).dismiss)) {
//        return Promise.reject('dismissed');
//    }
    (options || {}).prompt ? args.push(options.prompt) : false;
    return subscribe.apply(null, args);
}

export default subscribeByOptions;


//////////////////
// WEBPACK FOOTER
// ./src/app/composeable-subscribe.js
// module id = 5
// module chunks = 0